import { applyUpdate, dismissUpdate, useNeedRefresh } from '../lib/sw';

/**
 * Yeni sürüm kullanıcı onayıyla uygulanır (registerType: prompt). Taslaklar IndexedDB'de olduğu için
 * güncelleme kaydedilmemiş taslağı kaybettirmez (T25). Kayıt lib/sw.ts'de, uygulama açılırken yapılır.
 */
export function UpdatePrompt() {
  const needRefresh = useNeedRefresh();
  if (!needRefresh) return null;
  return (
    <div className="alert info row" role="status" style={{ borderRadius: 0 }}>
      <span>aksanenerji uygulamasının yeni sürümü hazır. Taslaklarınız cihazda korunur.</span>
      <span className="spacer" />
      <button className="btn small" onClick={dismissUpdate}>Sonra</button>
      <button className="btn small primary" onClick={applyUpdate}>Güncelle</button>
    </div>
  );
}
